<template>
  <main class="md:px-44 px-7">
    <section class="grid pt-9 pb-4 gap-16 content-start items-start w-full">
      <article v-if="this.$route.query?.status === 'true'" class="grid gap-8 md:w-80 md:mx-auto justify-center text-center">
        <p class="text-3xl font-blogger font-bold text-headingColor text-center">Congratulations!</p>
          <div class="h-64 w-64 grid justify-self-center">
            <Vue3Lottie ref="lottie" :animationData="CongratulationsGpayAnimation" :speed="1" :loop="true" />
          </div>
          <div class="grid gap-5 text-center">
            <span class="grid">
              <p class="text-center text-headingColor font-myriad text-base w-64">You have successfully completed your Aadhaar Esign</p>
            </span>
          </div>
      </article>
      <article v-else class="grid gap-8 md:w-80 md:mx-auto justify-center text-center">
          <div class="h-48 w-48 grid justify-self-center">
            <Vue3Lottie ref="lottie" :animationData="AutoCrossAnimation" :speed="1" :loop="true" />
          </div>
          <div class="grid gap-5 text-center">
            <span class="grid">
              <p class="text-center text-headingColor font-myriad text-base w-64">
                Your Aadhaar-ESign unsuccessful <br/>Please try again!!!
              </p>
            </span>
          </div>
      </article>
    </section>
    <span class="grid pb-24"></span>
    <section>
    </section>
    <!-- overLayGoBack -->
    <over-lay-go-back :starterOverLay="isOverLay" @on-click-back-prev="handleBackToPrev"/>
  </main>
</template>
  <script>
  import { mapGetters } from 'vuex';
  import overLayGoBack from '../components/overLayGoBack.vue';
  import AutoCrossAnimation from '../assets/animation/Auto-Cross-Animation.json';
import CongratulationsGpayAnimation from '../assets/animation/Congratulations-Gpay-Animation.json';

  export default {
    name: 'AadharEsignResult',
    components: {
      overLayGoBack
    },
    data() {
      return {
        isOverLay: undefined,
        AutoCrossAnimation,
        CongratulationsGpayAnimation,
        queryData: this.$route.query,
      };
    },
    computed: {
    ...mapGetters(['applicationId', 'latestLoanId']),
  },
    mounted() {
        setTimeout(() => {
        this.isOverLay = true;
      }, 4000);
    },
  methods: {
    handleBackToPrev() {
      this.isOverLay = false;
      setTimeout(() => {
        this.isOverLay = true;
      }, 4000);
    }
  }
  };
  </script>
